import combineReducers from '../../../utilities/combineReducers';
import entities from './entities';

export default combineReducers({
  entities,
});



// WEBPACK FOOTER //
// ./src/modules/sessions/reducers/index.js